module.exports = __webpack_public_path__ + "img/source_gf-01.6a51dec5.png";